import { useContext } from 'react'

import { CommunityConfigurationSidebarContext } from '../../context/communityConfigurationSidebar/communityConfigurationSidebarContext'

const useCommunityConfigurationSidebar = () => {
  const context = useContext(CommunityConfigurationSidebarContext)

  if (!context) {
    throw new Error(
      'useCommunityConfigurationSidebar must be used with a CommunityConfigurationSidebarProvider'
    )
  }

  return context
}

export default useCommunityConfigurationSidebar
